import { INVENTORY_MODULE } from "@/api_framework/api_config";
import { IServiceBillableResponse } from "@/api_framework/api_modals/Inventory";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { setLoading } from "@/app_redux/reducers/loading_reducer";
import { setServiceBillable } from "@/app_redux/reducers/slices/auth/inventory_slice";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback } from "react";
import toast from "react-hot-toast";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useAPIUtils } from "@/app/hooks/useAPIUtils";

AxiosCurlirize(axios, () => {});
export const useServiceBillableAPI = () => {
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();
  const configuration = useConfiguration();
  const execute = useCallback(
    async (serviceId: string, subServiceId: string) => {
      dispatch(
        setLoading({
          key: "isTaxListLoadingInProgress",
          status: true,
        }),
      );

      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        await axios
          .get(
            `${INVENTORY_MODULE?.SERVICE_BILLABLE?.baseURL}?service_id=${serviceId}&sub_service_id=${subServiceId}`,
            {
              headers: {
                Authorization: `${accessToken}`,
                "Content-Type": "application/json",
              },
            },
          )
          .then((res: AxiosResponse<IServiceBillableResponse>) => {
            if (res.data.status === true) {
              dispatch(setServiceBillable({ data: res.data.data }));
              dispatch(
                setLoading({
                  key: "isTaxListLoadingInProgress",
                  status: false,
                }),
              );
            } else {
              dispatch(setServiceBillable({ data: null }));
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
            dispatch(setServiceBillable({ data: null }));
            dispatch(
              setLoading({
                key: "isTaxListLoadingInProgress",
                status: false,
              }),
            );
            captureError(e);
          });
      } catch (e: any) {
        dispatch(setServiceBillable({ data: null }));
        toast.error("Server Error: " + e.message);
      }
    },
    [dispatch],
  );
  return execute;
};
